import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, mergeProps as _mergeProps, normalizeClass as _normalizeClass, createSlots as _createSlots, isRef as _isRef, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "course-lesson-page container-fix-padding" }
const _hoisted_3 = {
  id: "classroom-lesson-body",
  class: "course-detail-wrapper"
}
const _hoisted_4 = { class: "w-full d-flex justify-space-between align-center" }
const _hoisted_5 = { class: "d-flex align-center gap-3" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "d-flex justify-center w-full" }
const _hoisted_8 = {
  key: 0,
  class: "tooltiptext"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "course-main-area" }
const _hoisted_12 = { class: "d-flex align-center" }
const _hoisted_13 = { class: "d-flex align-center me-3" }
const _hoisted_14 = { class: "course-content-wrapper" }
const _hoisted_15 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 2,
  class: "classroom-practice-panel"
}
const _hoisted_18 = {
  key: 0,
  class: "practice-preparing",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_19 = { class: "practice-progress" }
const _hoisted_20 = { class: "practice-progress-label" }
const _hoisted_21 = {
  key: 0,
  class: "my-lesson-detail bg-white d-flex flex-column overflow-hidden h-100"
}
const _hoisted_22 = {
  key: 0,
  class: "youtube-video h-full w-full"
}
const _hoisted_23 = {
  key: 1,
  class: "vimeo-video h-full w-full"
}
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { class: "my-lesson-detail bg-white d-flex flex-column overflow-auto" }
const _hoisted_26 = {
  key: 0,
  class: "tutorial-box"
}
const _hoisted_27 = { class: "w-100 text-center" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "container" }
const _hoisted_30 = { class: "h3 fv-blod" }
const _hoisted_31 = { class: "container" }
const _hoisted_32 = { class: "row align-items-center" }
const _hoisted_33 = { class: "col-12 col-lg-5" }
const _hoisted_34 = { class: "d-md-flex align-items-center flex-wrap" }
const _hoisted_35 = { class: "col-12 col-lg-7" }
const _hoisted_36 = { class: "d-flex flex-wrap align-items-center justify-content-center justify-content-lg-end" }
const _hoisted_37 = {
  key: 2,
  class: "return-goal-row"
}
const _hoisted_38 = { class: "return-goal-btn__label" }
const _hoisted_39 = {
  class: "btn-group btn-group-sm bg-secondary align-items-center",
  role: "group"
}
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = {
  key: 3,
  class: "text-center position-absolute w-full h-full d-flex justify-space-between align-center",
  style: {"pointer-events":"none","top":"0"}
}
const _hoisted_43 = {
  key: 3,
  class: "text-center pt-5 py-1"
}
const _hoisted_44 = {
  key: 4,
  class: "bg-white mt-4 mb-1 p-2",
  style: {"min-height":"25vw"}
}
const _hoisted_45 = { class: "container" }
const _hoisted_46 = { class: "h3 fv-blod" }
const _hoisted_47 = { class: "container" }
const _hoisted_48 = { class: "row align-items-center" }
const _hoisted_49 = { class: "col-12 col-lg-5" }
const _hoisted_50 = { class: "d-md-flex align-items-center flex-wrap" }
const _hoisted_51 = { class: "col-12 col-lg-7 px-0" }
const _hoisted_52 = { class: "d-flex flex-wrap align-items-center justify-content-center justify-content-lg-end" }
const _hoisted_53 = {
  key: 2,
  class: "return-goal-row"
}
const _hoisted_54 = { class: "return-goal-btn__label" }
const _hoisted_55 = {
  class: "btn-group btn-group-sm bg-secondary align-items-center",
  role: "group"
}
const _hoisted_56 = { class: "subtitle" }
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = { class: "container my-4" }
const _hoisted_59 = ["innerHTML"]
const _hoisted_60 = { class: "lesson-side-tabs" }
const _hoisted_61 = {
  key: 0,
  class: "p-2 bg-white h-full"
}
const _hoisted_62 = { class: "question-list mb-4" }
const _hoisted_63 = { class: "header" }
const _hoisted_64 = {
  class: "px-3 h-full",
  style: {"overflow-y":"auto"}
}
const _hoisted_65 = {
  key: 0,
  flat: "",
  class: "p-2 mb-2 bg-white h-full"
}
const _hoisted_66 = { class: "v-list-item-action" }
const _hoisted_67 = { class: "v-list-item-action" }
const _hoisted_68 = { class: "v-list-item-action" }
const _hoisted_69 = { class: "v-list-item-action" }
const _hoisted_70 = {
  key: 1,
  class: "d-flex align-center justify-center",
  style: {"height":"70vh"}
}

import { ref, computed, watch, onMounted, onBeforeUnmount, onUpdated, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import UserQuestionList from '../organisms/UserQuestionList.vue'
import UserQuestionDialog from '../organisms/UserQuestionDialog.vue'
import ReviewDialog from '../organisms/ReviewDialog.vue'
import ReviewEditDialog from '../organisms/ReviewEditDialog.vue'
import CommentContainer from '../organisms/CommentContainer.vue'
import LessonPracticeHistory from '../organisms/LessonPracticeHistory.vue'
import ExamArtifactWorkspace from '../organisms/ExamArtifactWorkspace.vue'
import { useClassroomPractice } from '../../composables/useClassroomPractice'
import MesageContainer from '../organisms/MesageContainer.vue'
import ThreadContainer from '../organisms/ThreadContainer.vue'
import { useCourseMyDetail } from '../../composables/useCourseMyDetail'
import useHighlightActions from '../../composables/useHighlightActions'
import TeacherView from '../atoms_molecules/TeacherView.vue'
import UserQuestion from '../../../api/v2/models/user_question'
import UserQuestionDetailModal from '../organisms/UserQuestionDetailModal.vue'
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import LiveChat from "../organisms/LiveChat.vue"
import api from '../../../api/v2/api'
import trackingLesson from '../../trackings/lesson'

const PANE_SIZE_KEY = 'lesson_pane_size'

export default /*@__PURE__*/_defineComponent({
  __name: 'CourseMyDetailWeb',
  setup(__props) {

const { activeView, practiceTaking, setPracticeView, setLessonExamView, practiceDiscussion, discussPractice, practiceHistoryRevision, refreshPracticeHistory, practiceExamId, practiceGenerating, practiceProgress, showPractice, openPractice, setLatestPractice, onPracticeGenerating, onPracticeProgress, returnToLesson } = useClassroomPractice()
const route = useRoute()
const router = useRouter()
const courseIdStr = computed(() => Array.isArray(route.params.courseId) ? route.params.courseId[0] : route.params.courseId)

// Use the composable
const {
  mobile, course, courseLessons, currentLesson, courseMaterials, lessonMaterials,
  completedLessonCount, banners, review, chapters, isMobile, leftDrawer, rightDrawer,
  disabledNextBtn, disabledPreviousBtn, tab, currentLessonQuestionsCount,
  leftBarItems, lazyLoading, descriptionShowAll,
  user, schoolSetting, headerNavColor, headerNavTextColor, hamburgerColor, proccessCount,
  lessonIdQuery, lessonIdQueryNumber, tabQuery, currentLessonId, headerTitle, commentable,
  goNextLesson, previousLession, getBanner, goLesson, downloadFile, goToHome, onResize,
  finishLesson, revertFinishLesson, returnGoal, goBackToGoal, upVote, downVote, refetchQuestionsCount,
  initializeDefaultTab, updateReview, initCourse, markdownParser, toggleLeftDrawer, showRightMenu,
  onVideoPlay, onVideoPause, onVideoMilestone
} = useCourseMyDetail()

const { codeDialog, dialogHTML } = useHighlightActions()

const currentQuestion = ref<UserQuestion | null>(null)
const questionMode = ref<'list' | 'show' | 'new'>('list')
const newQuestionCreatedFlag = ref(false)
const resizeOb = ref<ResizeObserver | null>(null)
const showCreateThreadBtn = ref(true)
const isShowAll = ref<boolean | null>(null)

// Refs for DOM elements
const lessonSidebar = ref<HTMLElement | null>(null)
const lessonSidebarContainer = ref<any>(null)
const mesageContainer = ref<any>(null)
const liveChatContainer = ref<any>(null)

// Splitpanes size management
const contentPaneSize = ref((() => {
  const savedSize = localStorage.getItem('lesson_pane_size')
  if (savedSize) {
    const size = parseFloat(savedSize)
    if (!isNaN(size) && size >= 30 && size <= 80) return size
  }
  return 70
})())

const sidebarPaneSize = computed(() => 100 - contentPaneSize.value)

const computedOpenedGroups = computed(() => {
  try {
    if (isShowAll.value === true) {
      if (chapters.value && chapters.value.length > 0) {
        return chapters.value.map((chapter: any) => `chapter-${chapter.id}`)
      }
      return []
    } else if (isShowAll.value === false) {
      return []
    } else {
      if (currentLessonId.value && leftBarItems.value && leftBarItems.value.length > 0) {
        const currentItem = leftBarItems.value.find((item: any) => item.id?.toString() === currentLessonId.value?.toString())
        if (currentItem && currentItem.chapterId) {
          return [`chapter-${currentItem.chapterId}`]
        }
      }
      return []
    }
  } catch (e) {
    return []
  }
})

const toggleShowAll = () => {
  if (isShowAll.value === null || isShowAll.value === false) {
    isShowAll.value = true
  } else {
    isShowAll.value = false
  }
}

const onPaneResized = (event: any) => {
  if (!practiceTaking.value && event?.panes?.length === 2) {
    const firstPaneSize = event.panes[0].size
    if (firstPaneSize >= 30 && firstPaneSize <= 80) {
      contentPaneSize.value = firstPaneSize
      localStorage.setItem(PANE_SIZE_KEY, String(firstPaneSize))
    }
  }
}

const updateParentTab = (value: number | string) => {
  if (typeof value === 'number') {
    const tabMap: Record<number, string> = { 0: 'LIVECHAT', 1: 'CHAT', 2: 'THREAD', 3: 'QA', 4: 'MATERIAL' }
    tab.value = tabMap[value] || 'QA'
  } else {
    tab.value = value
  }
}

const onClickQuestion = (question: UserQuestion) => {
  currentQuestion.value = question
  questionMode.value = 'show'
  newQuestionCreatedFlag.value = false
}

const onBackQuestionList = () => {
  currentQuestion.value = null
  questionMode.value = 'list'
  newQuestionCreatedFlag.value = false
}

const emitCreateThread = (value: number | string) => {
  if (typeof value === 'number') {
    const tabMap: Record<number, string> = { 0: 'LIVECHAT', 1: 'CHAT', 2: 'THREAD', 3: 'QA', 4: 'MATERIAL' }
    tab.value = tabMap[value] || 'CHAT'
  } else {
    tab.value = value
  }
  mesageContainer.value?.createThread()
}

const toggleCreateThreadBtn = (value: boolean) => {
  showCreateThreadBtn.value = value
}

const scrollLiveChatToBottom = () => {
  setTimeout(() => liveChatContainer.value?.scrollToLast(), 250)
}

const scrollChatToBottom = () => {
  setTimeout(() => mesageContainer.value?.scrollToLast(), 250)
}

// Watch tab changes
watch(tab, () => {
  nextTick(() => {
    if (!currentLesson.value) return
    const params = new URLSearchParams(window.location.search)
    const validTabs = ['LIVECHAT', 'CHAT', 'THREAD', 'QA', 'MATERIAL']
    if (!tab.value || !validTabs.includes(tab.value as string)) {
      tab.value = currentLesson.value.lesson.lessonType == 'live' ? 'LIVECHAT' : 'QA'
    }
    params.set('tab', tab.value as string)
    window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`))
  })
})

// Watch route changes
watch(() => route.query, async (newQuery, oldQuery) => {
  if (newQuery.lesson_id && newQuery.lesson_id === oldQuery?.lesson_id) return
  if (!currentLesson.value || !courseLessons.value.length) return

  try {
    const unlearntLessons = courseLessons.value.filter(lesson => !lesson.isLearnt).slice(0, 1)
    const lessonId = lessonIdQueryNumber.value || (unlearntLessons.length > 0 ? Number(unlearntLessons[0].lesson.id) : Number(courseLessons.value[0].lesson.id))
    currentLesson.value = await api.courseLesson.show({
      courseId: route.params.courseId as string,
      id: lessonId,
      ...route.query
    })
    lessonMaterials.value = await api.lesson.materials({
      lessonId: currentLesson.value?.lesson?.id?.toString()
    })
  } catch (error) {
    console.error(error)
  }

  nextTick(() => {
    if (currentLesson.value?.lesson?.lessonType !== 'live' && !tab.value) {
      tab.value = schoolSetting.value?.useAiChatLesson ? 'CHAT' : 'QA'
    }
    if (currentLesson.value?.lesson?.lessonType === 'live') {
      tab.value = 'LIVECHAT'
    }
  })
  refetchQuestionsCount()
})

onMounted(async () => {
  await initCourse()
  onResize()

  const validTabs = ['LIVECHAT', 'CHAT', 'THREAD', 'QA', 'MATERIAL']
  if (tabQuery.value && validTabs.includes(tabQuery.value)) {
    tab.value = tabQuery.value
  } else {
    initializeDefaultTab()
  }
  
  window.addEventListener('resize', onResize)
})

onUpdated(() => {
  nextTick(() => {
    setTimeout(() => {
      if (resizeOb.value === undefined) return
      const sidebar = lessonSidebar.value
      const containerRef = lessonSidebarContainer.value
      const container = containerRef?.$el || containerRef

      if (!sidebar || !container || !(container instanceof Element)) return

      resizeOb.value = new ResizeObserver((entries) => {
        let rect = entries[0].contentRect
        let width = rect.width
        sidebar.style.width = width + "px"
      })

      try {
        resizeOb.value.observe(container)
      } catch (error) {
        console.warn('Failed to observe lessonSidebarContainer:', error)
      }
    }, 500)
  })
})

onBeforeUnmount(() => {
  if (resizeOb.value) {
    try {
      const containerRef = lessonSidebarContainer.value
      const container = containerRef?.$el || containerRef
      if (container && container instanceof Element) {
        resizeOb.value.unobserve(container)
      }
      resizeOb.value.disconnect()
    } catch (error) {}
  }
  trackingLesson.stop()
  if (typeof window !== 'undefined') {
    window.removeEventListener('resize', onResize)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_video_wrapper = _resolveComponent("video-wrapper")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_unref(currentLesson))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createCommentVNode(" Left Sidebar - Persistent drawer, pushes content "),
            _createVNode(_component_v_navigation_drawer, {
              modelValue: _unref(leftDrawer),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(leftDrawer) ? (leftDrawer).value = $event : null)),
              theme: "dark",
              class: "course-left-drawer",
              width: "256"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_toolbar, {
                  class: "cursor-pointer back-home-btn",
                  onClick: _unref(goToHome)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_v_icon, { size: "36" }, {
                        default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                          _createTextVNode("mdi-chevron-left", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }),
                      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "flex-grow-1 text-left" }, "戻る", -1 /* CACHED */))
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"]),
                _createVNode(_component_v_list, {
                  class: "sidebar-list my-course-sidebar",
                  density: "compact",
                  opened: computedOpenedGroups.value
                }, {
                  default: _withCtx(() => [
                    (_unref(chapters).length > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(leftBarItems).filter(item => item.type == 'header'), (item) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              key: `header-{item.id}`,
                              onClick: ($event: any) => (item.action())
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_5, [
                                  (item.image)
                                    ? (_openBlock(), _createBlock(_component_v_avatar, {
                                        key: 0,
                                        size: "40"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("img", {
                                            src: item.image
                                          }, null, 8 /* PROPS */, _hoisted_6)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */))
                                    : _createCommentVNode("v-if", true),
                                  _createVNode(_component_v_list_item_title, {
                                    innerHTML: item.title
                                  }, null, 8 /* PROPS */, ["innerHTML"])
                                ])
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                          }), 128 /* KEYED_FRAGMENT */)),
                          _createVNode(_component_v_list_item, { class: "py-2" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_7, [
                                _createVNode(_component_v_btn, {
                                  class: "show-all-btn",
                                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (toggleShowAll()), ["stop"]))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(isShowAll.value ? 'チャプターのみ表示' : 'すべて表示'), 1 /* TEXT */),
                                    _createVNode(_component_v_icon, { size: "18" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(isShowAll.value ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1 /* TEXT */)
                                      ]),
                                      _: 1 /* STABLE */
                                    })
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ])
                            ]),
                            _: 1 /* STABLE */
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chapters), (chapter) => {
                            return (_openBlock(), _createBlock(_component_v_list_group, {
                              key: chapter.id,
                              color: "white",
                              class: _normalizeClass(!isShowAll.value && _unref(leftBarItems).some(item => item.chapterId == chapter.id && item.id.toString() == _unref(currentLessonId)) ? 'v-list-item--active-expanded' : ''),
                              value: `chapter-${chapter.id}`
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props, { class: "px-0" }), {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(chapter.name), 1 /* TEXT */)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1024 /* DYNAMIC_SLOTS */),
                                    (chapter.name.length > 13)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(chapter.name), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(leftBarItems).filter(item => item.chapterId == chapter.id), (item) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    id: `left-bar-item-${item.id}`,
                                    key: `${chapter.id}-${item.id}`,
                                    onClick: ($event: any) => (item.action ? item.action() : undefined),
                                    "id-value": item.id.toString(),
                                    "current-lesson-id": _unref(currentLessonId).toString(),
                                    class: _normalizeClass(item.id.toString() === _unref(currentLessonId).toString() ? 'v-item--active-custom' : '')
                                  }, _createSlots({
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, {
                                        innerHTML: item.title
                                      }, null, 8 /* PROPS */, ["innerHTML"])
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, [
                                    (item.type != 'subheader')
                                      ? {
                                          name: "prepend",
                                          fn: _withCtx(() => [
                                            _createVNode(_component_v_icon, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item.icon), 1 /* TEXT */)
                                              ]),
                                              _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                          ]),
                                          key: "0"
                                        }
                                      : (item.image)
                                        ? {
                                            name: "prepend",
                                            fn: _withCtx(() => [
                                              _createVNode(_component_v_avatar, { size: "40" }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("img", {
                                                    src: item.image
                                                  }, null, 8 /* PROPS */, _hoisted_9)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                              }, 1024 /* DYNAMIC_SLOTS */)
                                            ]),
                                            key: "1"
                                          }
                                        : undefined
                                  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "onClick", "id-value", "current-lesson-id", "class"]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "value"]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(leftBarItems), (item, index) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            id: `left-bar-item-${item.id}`,
                            key: index,
                            disabled: item.type == 'subheader' || item.id.toString() == _unref(currentLessonId).toString(),
                            onClick: ($event: any) => (item.action ? item.action() : undefined),
                            "id-value": item.id.toString(),
                            "current-lesson-id": _unref(currentLessonId).toString(),
                            class: _normalizeClass(item.id.toString() == _unref(currentLessonId).toString() ? 'v-item--active-custom' : '')
                          }, _createSlots({
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, {
                                innerHTML: item.title
                              }, null, 8 /* PROPS */, ["innerHTML"])
                            ]),
                            _: 2 /* DYNAMIC */
                          }, [
                            (item.type == 'item')
                              ? {
                                  name: "prepend",
                                  fn: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.icon), 1 /* TEXT */)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1024 /* DYNAMIC_SLOTS */)
                                  ]),
                                  key: "0"
                                }
                              : (item.image)
                                ? {
                                    name: "prepend",
                                    fn: _withCtx(() => [
                                      _createVNode(_component_v_avatar, { size: "40" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("img", {
                                            src: item.image
                                          }, null, 8 /* PROPS */, _hoisted_10)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1024 /* DYNAMIC_SLOTS */)
                                    ]),
                                    key: "1"
                                  }
                                : undefined
                          ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "disabled", "onClick", "id-value", "current-lesson-id", "class"]))
                        }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["opened"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]),
            _createCommentVNode(" Main content area - Vuetify automatically handles padding via v-main "),
            _createElementVNode("div", _hoisted_11, [
              _createCommentVNode(" Custom Header - using v-toolbar instead of v-app-bar to avoid auto positioning "),
              _createVNode(_component_v_toolbar, {
                color: _unref(headerNavColor),
                class: "course-header",
                flat: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_v_btn, {
                      icon: true,
                      variant: "text",
                      onClick: _unref(toggleLeftDrawer),
                      style: _normalizeStyle(_unref(hamburgerColor))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                            _createTextVNode("mdi-menu", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick", "style"]),
                    _createVNode(_component_v_toolbar_title, {
                      class: "header-title",
                      style: _normalizeStyle({ 'color': _unref(headerNavTextColor) })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(headerTitle)), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["style"])
                  ]),
                  _createVNode(_component_v_spacer),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", null, [
                      (_unref(review).body)
                        ? (_openBlock(), _createBlock(ReviewEditDialog, {
                            key: 0,
                            courseId: courseIdStr.value,
                            review: _unref(review)
                          }, null, 8 /* PROPS */, ["courseId", "review"]))
                        : (_openBlock(), _createBlock(ReviewDialog, {
                            key: 1,
                            courseId: courseIdStr.value,
                            onUpdateReview: _unref(updateReview)
                          }, null, 8 /* PROPS */, ["courseId", "onUpdateReview"]))
                    ]),
                    _createElementVNode("div", {
                      class: "ms-2",
                      style: _normalizeStyle({ 'color': _unref(headerNavTextColor) })
                    }, " 進捗率 " + _toDisplayString(_unref(proccessCount)), 5 /* TEXT, STYLE */)
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["color"]),
              _createCommentVNode(" Content Area "),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_unref(Splitpanes), {
                  class: _normalizeClass(["default-theme lesson-splitpanes", { 'practice-taking': _unref(practiceTaking) }]),
                  onResized: onPaneResized
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Pane), {
                      class: "lesson-content-pane",
                      size: _unref(currentLesson).lesson.isExam || _unref(practiceTaking) ? 100 : contentPaneSize.value,
                      "min-size": 30
                    }, {
                      default: _withCtx(() => [
                        (!_unref(currentLesson).lesson.isExam && _unref(getBanner)('lesson_top'))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createElementVNode("div", {
                                innerHTML: _unref(getBanner)('lesson_top').bodyHtml
                              }, null, 8 /* PROPS */, _hoisted_16)
                            ]))
                          : _createCommentVNode("v-if", true),
                        (_unref(schoolSetting) && _unref(schoolSetting).useAiChatLesson)
                          ? (_openBlock(), _createBlock(LessonPracticeHistory, {
                              key: _unref(currentLesson).lesson.id,
                              "lesson-id": Number(_unref(currentLesson).lesson.id),
                              "course-id": Number(courseIdStr.value),
                              "refresh-key": `${_unref(practiceExamId)}:${_unref(practiceHistoryRevision)}`,
                              "artifact-visible": _unref(showPractice),
                              onOpen: _unref(openPractice),
                              onLatest: _unref(setLatestPractice)
                            }, null, 8 /* PROPS */, ["lesson-id", "course-id", "refresh-key", "artifact-visible", "onOpen", "onLatest"]))
                          : _createCommentVNode("v-if", true),
                        (_unref(practiceExamId) || _unref(practiceGenerating))
                          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createElementVNode("button", {
                                class: "practice-back",
                                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(returnToLesson) && _unref(returnToLesson)(...args)))
                              }, "← 教材に戻る"),
                              (_unref(practiceGenerating))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _cache[23] || (_cache[23] = _createElementVNode("h3", null, "練習問題を作成しています", -1 /* CACHED */)),
                                    _createElementVNode("p", null, _toDisplayString(_unref(practiceProgress).stage), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_19, [
                                      _createVNode(_component_v_progress_linear, {
                                        "model-value": _unref(practiceProgress).progress,
                                        color: "primary",
                                        height: "12",
                                        rounded: ""
                                      }, null, 8 /* PROPS */, ["model-value"])
                                    ]),
                                    _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(practiceProgress).progress) + "% · 完了までこの画面でお待ちください", 1 /* TEXT */)
                                  ]))
                                : (_unref(practiceExamId))
                                  ? (_openBlock(), _createBlock(ExamArtifactWorkspace, {
                                      key: _unref(practiceExamId),
                                      onActiveView: _unref(setPracticeView),
                                      onFinished: _unref(refreshPracticeHistory),
                                      onDiscuss: _unref(discussPractice),
                                      "exam-id": _unref(practiceExamId),
                                      "lesson-id": Number(_unref(currentLesson).lesson.id),
                                      "course-id": Number(courseIdStr.value),
                                      inline: ""
                                    }, null, 8 /* PROPS */, ["onActiveView", "onFinished", "onDiscuss", "exam-id", "lesson-id", "course-id"]))
                                  : _createCommentVNode("v-if", true)
                            ], 512 /* NEED_PATCH */)), [
                              [_vShow, _unref(showPractice)]
                            ])
                          : _createCommentVNode("v-if", true),
                        _withDirectives(_createElementVNode("div", {
                          class: _normalizeClass(['position-relative', { 'h-100': _unref(currentLesson).lesson.isExam }])
                        }, [
                          _createCommentVNode(" for exam lesson "),
                          (_unref(currentLesson).lesson.isExam)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                (_unref(currentLesson).lesson.examId)
                                  ? (_openBlock(), _createBlock(ExamArtifactWorkspace, {
                                      key: _unref(currentLesson).lesson.examId,
                                      onActiveView: _unref(setLessonExamView),
                                      "lesson-exam": "",
                                      "exam-id": Number(_unref(currentLesson).lesson.examId),
                                      "lesson-id": Number(_unref(currentLesson).lesson.id),
                                      "course-id": Number(courseIdStr.value)
                                    }, null, 8 /* PROPS */, ["onActiveView", "exam-id", "lesson-id", "course-id"]))
                                  : _createCommentVNode("v-if", true)
                              ]))
                            : (!_unref(currentLesson).lesson.isText)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createCommentVNode(" for video lesson "),
                                  _createElementVNode("div", {
                                    class: "my-lesson-detail bg-white d-flex flex-column overflow-hidden",
                                    style: _normalizeStyle(!_unref(currentLesson).lesson.isVideo ? 'height: 35vw' : '')
                                  }, [
                                    (_unref(currentLesson) && _unref(lazyLoading))
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createCommentVNode(" Video content - removed empty template wrapper that caused display:none "),
                                          (_unref(currentLesson).lesson.video)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                (_openBlock(), _createBlock(_component_video_wrapper, {
                                                  key: `${_unref(currentLesson).lesson.id}-${_unref(currentLesson).lesson.video}`,
                                                  player: "youtube",
                                                  videoId: _unref(currentLesson).lesson.video,
                                                  courseId: _unref(course)?.id,
                                                  lessonId: _unref(currentLesson).lesson.id,
                                                  analyticsEnabled: _unref(user)?.videoAnalyticsEnabled,
                                                  options: { responsive: true },
                                                  onPlay: _unref(onVideoPlay),
                                                  onPause: _unref(onVideoPause),
                                                  onMilestone: _unref(onVideoMilestone)
                                                }, null, 8 /* PROPS */, ["videoId", "courseId", "lessonId", "analyticsEnabled", "onPlay", "onPause", "onMilestone"]))
                                              ]))
                                            : _createCommentVNode("v-if", true),
                                          (_unref(currentLesson).lesson.vimeo)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                (_openBlock(), _createBlock(_component_video_wrapper, {
                                                  key: `${_unref(currentLesson).lesson.id}-${_unref(currentLesson).lesson.vimeo}`,
                                                  player: "vimeo",
                                                  videoId: _unref(currentLesson).lesson.vimeo,
                                                  courseId: _unref(course)?.id,
                                                  lessonId: _unref(currentLesson).lesson.id,
                                                  analyticsEnabled: _unref(user)?.videoAnalyticsEnabled,
                                                  options: { responsive: true },
                                                  onPlay: _unref(onVideoPlay),
                                                  onPause: _unref(onVideoPause),
                                                  onMilestone: _unref(onVideoMilestone)
                                                }, null, 8 /* PROPS */, ["videoId", "courseId", "lessonId", "analyticsEnabled", "onPlay", "onPause", "onMilestone"]))
                                              ]))
                                            : _createCommentVNode("v-if", true)
                                        ], 64 /* STABLE_FRAGMENT */))
                                      : _createCommentVNode("v-if", true),
                                    (_unref(getBanner)('lesson_bottom'))
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          innerHTML: _unref(getBanner)('lesson_bottom').bodyHtml
                                        }, null, 8 /* PROPS */, _hoisted_24))
                                      : _createCommentVNode("v-if", true)
                                  ], 4 /* STYLE */)
                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createCommentVNode(" for text lesson "),
                                  _createElementVNode("div", _hoisted_25, [
                                    (_unref(currentLesson) && _unref(lazyLoading))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                          _createElementVNode("div", _hoisted_27, [
                                            (_unref(currentLesson).lesson.imageUrl)
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 0,
                                                  src: _unref(currentLesson).lesson.imageUrl,
                                                  class: "my-0"
                                                }, null, 8 /* PROPS */, _hoisted_28))
                                              : _createCommentVNode("v-if", true)
                                          ]),
                                          _createElementVNode("section", _hoisted_29, [
                                            (_unref(returnGoal))
                                              ? (_openBlock(), _createElementBlock("a", {
                                                  key: 0,
                                                  href: "#",
                                                  class: "return-goal-link",
                                                  onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_unref(goBackToGoal) && _unref(goBackToGoal)(...args)), ["prevent"]))
                                                }, [
                                                  _createVNode(_component_v_icon, { size: "16" }, {
                                                    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                                      _createTextVNode("mdi-chevron-left", -1 /* CACHED */)
                                                    ]))]),
                                                    _: 1 /* STABLE */
                                                  }),
                                                  _createTextVNode("ゴール（" + _toDisplayString(_unref(returnGoal).name) + "） ", 1 /* TEXT */)
                                                ]))
                                              : _createCommentVNode("v-if", true),
                                            _createElementVNode("h2", _hoisted_30, _toDisplayString(_unref(currentLesson).lesson.name), 1 /* TEXT */),
                                            _createElementVNode("div", _hoisted_31, [
                                              _createElementVNode("div", _hoisted_32, [
                                                _createElementVNode("div", _hoisted_33, [
                                                  _createElementVNode("div", _hoisted_34, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentLesson).lesson.teachers, (teacher) => {
                                                      return (_openBlock(), _createBlock(TeacherView, {
                                                        class: "p-1",
                                                        key: teacher.id,
                                                        teacher: teacher
                                                      }, null, 8 /* PROPS */, ["teacher"]))
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_35, [
                                                  _createElementVNode("div", _hoisted_36, [
                                                    (!_unref(currentLesson).isLearnt)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 0,
                                                          variant: "outlined",
                                                          class: "mr-2",
                                                          onClick: _unref(finishLesson)
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_icon, { class: "me-1" }, {
                                                              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                                                _createTextVNode(" mdi-check-circle ", -1 /* CACHED */)
                                                              ]))]),
                                                              _: 1 /* STABLE */
                                                            }),
                                                            _cache[26] || (_cache[26] = _createTextVNode(" 学習を完了する ", -1 /* CACHED */))
                                                          ]),
                                                          _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["onClick"]))
                                                      : _createCommentVNode("v-if", true),
                                                    (_unref(currentLesson).isLearnt)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 1,
                                                          class: "mr-2",
                                                          variant: "outlined",
                                                          color: "success",
                                                          onClick: _unref(revertFinishLesson)
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_icon, { class: "me-1" }, {
                                                              default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                                                _createTextVNode(" mdi-check-circle ", -1 /* CACHED */)
                                                              ]))]),
                                                              _: 1 /* STABLE */
                                                            }),
                                                            _cache[28] || (_cache[28] = _createTextVNode(" 学習完了をもどす ", -1 /* CACHED */))
                                                          ]),
                                                          _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["onClick"]))
                                                      : _createCommentVNode("v-if", true),
                                                    (_unref(currentLesson).isLearnt && _unref(returnGoal))
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                                          _createVNode(_component_v_btn, {
                                                            class: "return-goal-btn",
                                                            color: "primary",
                                                            variant: "flat",
                                                            onClick: _unref(goBackToGoal)
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_icon, { class: "me-1" }, {
                                                                default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                                                  _createTextVNode("mdi-flag-variant-outline", -1 /* CACHED */)
                                                                ]))]),
                                                                _: 1 /* STABLE */
                                                              }),
                                                              _createElementVNode("span", _hoisted_38, "ゴール（" + _toDisplayString(_unref(returnGoal).name) + "）に戻る", 1 /* TEXT */)
                                                            ]),
                                                            _: 1 /* STABLE */
                                                          }, 8 /* PROPS */, ["onClick"])
                                                        ]))
                                                      : _createCommentVNode("v-if", true),
                                                    _createElementVNode("div", _hoisted_39, [
                                                      _createElementVNode("div", {
                                                        class: "btn btn-secondary pe-3 text-white",
                                                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(upVote)()))
                                                      }, [
                                                        _cache[30] || (_cache[30] = _createElementVNode("i", { class: "bi bi-hand-thumbs-up pe-1" }, null, -1 /* CACHED */)),
                                                        _cache[31] || (_cache[31] = _createElementVNode("div", { class: "d-none d-md-inline" }, "わかりやすい", -1 /* CACHED */)),
                                                        _createTextVNode(" " + _toDisplayString(_unref(currentLesson).lesson.voteValues), 1 /* TEXT */)
                                                      ]),
                                                      _createElementVNode("div", {
                                                        class: "btn btn-secondary border-start ps-2 text-white",
                                                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(downVote)()))
                                                      }, [...(_cache[32] || (_cache[32] = [
                                                        _createElementVNode("i", { class: "bi bi-hand-thumbs-down" }, null, -1 /* CACHED */)
                                                      ]))])
                                                    ])
                                                  ])
                                                ])
                                              ]),
                                              _createCommentVNode(" /.row ")
                                            ]),
                                            _createCommentVNode(" /container ")
                                          ]),
                                          (_unref(currentLesson).lesson.mdBody)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: "p-4",
                                                innerHTML: _unref(currentLesson).lesson.mdBody
                                              }, null, 8 /* PROPS */, _hoisted_40))
                                            : _createCommentVNode("v-if", true)
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    (_unref(getBanner)('lesson_bottom'))
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          innerHTML: _unref(getBanner)('lesson_bottom').bodyHtml
                                        }, null, 8 /* PROPS */, _hoisted_41))
                                      : _createCommentVNode("v-if", true)
                                  ])
                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
                          _createCommentVNode(" Navigation arrows - prev/next lesson "),
                          (!_unref(currentLesson).lesson.isText && !_unref(currentLesson).lesson.isExam)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                _createVNode(_component_v_btn, {
                                  class: "move-btn",
                                  style: {"pointer-events":"auto"},
                                  icon: "",
                                  variant: "flat",
                                  color: "rgba(0,0,0,0.4)",
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(previousLession)())),
                                  disabled: _unref(disabledPreviousBtn)
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { color: "white" }, {
                                      default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                        _createTextVNode("mdi-chevron-left", -1 /* CACHED */)
                                      ]))]),
                                      _: 1 /* STABLE */
                                    })
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["disabled"]),
                                _createVNode(_component_v_btn, {
                                  class: "move-btn",
                                  style: {"pointer-events":"auto"},
                                  icon: "",
                                  variant: "flat",
                                  color: "rgba(0,0,0,0.4)",
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(goNextLesson)())),
                                  disabled: _unref(disabledNextBtn)
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { color: "white" }, {
                                      default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                                        _createTextVNode("mdi-chevron-right", -1 /* CACHED */)
                                      ]))]),
                                      _: 1 /* STABLE */
                                    })
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["disabled"])
                              ]))
                            : _createCommentVNode("v-if", true)
                        ], 2 /* CLASS */), [
                          [_vShow, !_unref(showPractice)]
                        ]),
                        (_unref(currentLesson).lesson.isText)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                              _createVNode(_component_v_btn, {
                                class: "text-white me-2",
                                color: "cyan",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(previousLession)())),
                                disabled: _unref(disabledPreviousBtn)
                              }, {
                                default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                  _createTextVNode(" 前のレッスン ", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["disabled"]),
                              _createVNode(_component_v_btn, {
                                class: "text-white",
                                color: "cyan",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(goNextLesson)())),
                                disabled: _unref(disabledNextBtn)
                              }, {
                                default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                  _createTextVNode(" 次のレッスン ", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["disabled"])
                            ]))
                          : _createCommentVNode("v-if", true),
                        (!_unref(currentLesson).lesson.isExam)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                              _createElementVNode("section", _hoisted_45, [
                                (_unref(returnGoal))
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      href: "#",
                                      class: "return-goal-link",
                                      onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_unref(goBackToGoal) && _unref(goBackToGoal)(...args)), ["prevent"]))
                                    }, [
                                      _createVNode(_component_v_icon, { size: "16" }, {
                                        default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                                          _createTextVNode("mdi-chevron-left", -1 /* CACHED */)
                                        ]))]),
                                        _: 1 /* STABLE */
                                      }),
                                      _createTextVNode("ゴール（" + _toDisplayString(_unref(returnGoal).name) + "） ", 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                _createElementVNode("h2", _hoisted_46, _toDisplayString(_unref(currentLesson).lesson.name), 1 /* TEXT */),
                                _createElementVNode("div", _hoisted_47, [
                                  _createElementVNode("div", _hoisted_48, [
                                    _createElementVNode("div", _hoisted_49, [
                                      _createElementVNode("div", _hoisted_50, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentLesson).lesson.teachers, (teacher) => {
                                          return (_openBlock(), _createBlock(TeacherView, {
                                            class: "p-1",
                                            key: teacher.id,
                                            teacher: teacher
                                          }, null, 8 /* PROPS */, ["teacher"]))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_51, [
                                      _createElementVNode("div", _hoisted_52, [
                                        _createCommentVNode(" Removed empty template wrapper "),
                                        (!_unref(currentLesson).isLearnt)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              variant: "outlined",
                                              class: "mr-2",
                                              onClick: _unref(finishLesson)
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_icon, { class: "me-1" }, {
                                                  default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                                                    _createTextVNode(" mdi-check-circle ", -1 /* CACHED */)
                                                  ]))]),
                                                  _: 1 /* STABLE */
                                                }),
                                                _cache[39] || (_cache[39] = _createTextVNode(" 学習を完了する ", -1 /* CACHED */))
                                              ]),
                                              _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["onClick"]))
                                          : _createCommentVNode("v-if", true),
                                        (_unref(currentLesson).isLearnt)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 1,
                                              class: "mr-2",
                                              variant: "outlined",
                                              color: "success",
                                              onClick: _unref(revertFinishLesson)
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_icon, { class: "me-1" }, {
                                                  default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                                                    _createTextVNode(" mdi-check-circle ", -1 /* CACHED */)
                                                  ]))]),
                                                  _: 1 /* STABLE */
                                                }),
                                                _cache[41] || (_cache[41] = _createTextVNode(" 学習完了をもどす ", -1 /* CACHED */))
                                              ]),
                                              _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["onClick"]))
                                          : _createCommentVNode("v-if", true),
                                        (_unref(currentLesson).isLearnt && _unref(returnGoal))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                              _createVNode(_component_v_btn, {
                                                class: "return-goal-btn",
                                                color: "primary",
                                                variant: "flat",
                                                onClick: _unref(goBackToGoal)
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, { class: "me-1" }, {
                                                    default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                                      _createTextVNode("mdi-flag-variant-outline", -1 /* CACHED */)
                                                    ]))]),
                                                    _: 1 /* STABLE */
                                                  }),
                                                  _createElementVNode("span", _hoisted_54, "ゴール（" + _toDisplayString(_unref(returnGoal).name) + "）に戻る", 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                              }, 8 /* PROPS */, ["onClick"])
                                            ]))
                                          : _createCommentVNode("v-if", true),
                                        _createElementVNode("div", _hoisted_55, [
                                          _createElementVNode("div", {
                                            class: "btn btn-secondary pe-3 text-white",
                                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(upVote)()))
                                          }, [
                                            _cache[43] || (_cache[43] = _createElementVNode("i", { class: "bi bi-hand-thumbs-up pe-1" }, null, -1 /* CACHED */)),
                                            _cache[44] || (_cache[44] = _createElementVNode("div", { class: "d-none d-md-inline" }, "わかりやすい", -1 /* CACHED */)),
                                            _createTextVNode(" " + _toDisplayString(_unref(currentLesson).lesson.voteValues), 1 /* TEXT */)
                                          ]),
                                          _createElementVNode("div", {
                                            class: "btn btn-secondary border-start ps-2 text-white",
                                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(downVote)()))
                                          }, [...(_cache[45] || (_cache[45] = [
                                            _createElementVNode("i", { class: "bi bi-hand-thumbs-down" }, null, -1 /* CACHED */)
                                          ]))])
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _createCommentVNode(" /.row "),
                                  _createElementVNode("div", _hoisted_56, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(!_unref(descriptionShowAll) && 'subtitle-info')
                                    }, [
                                      _createElementVNode("div", {
                                        innerHTML: _unref(markdownParser)(_unref(currentLesson).lesson.description)
                                      }, null, 8 /* PROPS */, _hoisted_57)
                                    ], 2 /* CLASS */),
                                    (_unref(currentLesson).lesson.description && _unref(currentLesson).lesson.description.length > 100 && !_unref(descriptionShowAll))
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          onClick: _cache[13] || (_cache[13] = ($event: any) => (descriptionShowAll.value = !_unref(descriptionShowAll))),
                                          "aria-label": "もっと見る",
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#subtitleModal"
                                        }, " ...もっと見る "))
                                      : _createCommentVNode("v-if", true)
                                  ])
                                ]),
                                _createCommentVNode(" /container ")
                              ]),
                              _createVNode(_component_v_divider, { class: "my-4" }),
                              _createElementVNode("section", _hoisted_58, [
                                _cache[46] || (_cache[46] = _createElementVNode("h3", { class: "h5 fw-bold mb-3" }, "コメント", -1 /* CACHED */)),
                                _createVNode(CommentContainer, {
                                  class: "p-4 border rounded",
                                  commentable: _unref(commentable),
                                  user: _unref(user)
                                }, null, 8 /* PROPS */, ["commentable", "user"])
                              ])
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["size"]),
                    (!_unref(currentLesson).lesson.isExam)
                      ? (_openBlock(), _createBlock(_unref(Pane), {
                          key: 0,
                          id: "lessonSidebarContainer",
                          class: "lesson-sidebar-pane",
                          ref_key: "lessonSidebarContainer",
                          ref: lessonSidebarContainer,
                          size: _unref(practiceTaking) ? 0 : sidebarPaneSize.value,
                          "min-size": _unref(practiceTaking) ? 0 : 20
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", {
                              ref_key: "lessonSidebar",
                              ref: lessonSidebar,
                              class: "lesson-side-bar"
                            }, [
                              (_unref(getBanner)('my_lesson_right_sidebar_top'))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "sidebar-top-banner",
                                    innerHTML: _unref(getBanner)('my_lesson_right_sidebar_top').bodyHtml
                                  }, null, 8 /* PROPS */, _hoisted_59))
                                : _createCommentVNode("v-if", true),
                              _createCommentVNode(" タブと「新規スレッド」を横に並べる（ボタンをタブに重ねると、右側が狭いとき文字が欠けて押しにくい） "),
                              _createElementVNode("div", _hoisted_60, [
                                _createVNode(_component_v_tabs, {
                                  modelValue: _unref(tab),
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_isRef(tab) ? (tab).value = $event : null)),
                                  class: "lesson-side-tabs__tabs"
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_v_tab, {
                                      value: "LIVECHAT",
                                      onClick: scrollLiveChatToBottom
                                    }, {
                                      default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                                        _createTextVNode("LIVECHAT", -1 /* CACHED */)
                                      ]))]),
                                      _: 1 /* STABLE */
                                    }, 512 /* NEED_PATCH */), [
                                      [_vShow, _unref(currentLesson).lesson.lessonType == 'live']
                                    ]),
                                    (_unref(currentLessonId) && _unref(schoolSetting) && _unref(schoolSetting).useAiChatLesson)
                                      ? (_openBlock(), _createBlock(_component_v_tab, {
                                          key: 0,
                                          value: "CHAT",
                                          onClick: scrollChatToBottom
                                        }, {
                                          default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                                            _createTextVNode("チャット", -1 /* CACHED */)
                                          ]))]),
                                          _: 1 /* STABLE */
                                        }))
                                      : _createCommentVNode("v-if", true),
                                    (_unref(currentLessonId) && _unref(schoolSetting) && _unref(schoolSetting).useAiChatLesson)
                                      ? (_openBlock(), _createBlock(_component_v_tab, {
                                          key: 1,
                                          value: "THREAD"
                                        }, {
                                          default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                                            _createTextVNode("スレッド", -1 /* CACHED */)
                                          ]))]),
                                          _: 1 /* STABLE */
                                        }))
                                      : _createCommentVNode("v-if", true),
                                    _createVNode(_component_v_tab, { value: "QA" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("質問 (" + _toDisplayString(_unref(currentLessonQuestionsCount)) + ")", 1 /* TEXT */)
                                      ]),
                                      _: 1 /* STABLE */
                                    }),
                                    (_unref(courseMaterials).length + _unref(lessonMaterials).length > 0)
                                      ? (_openBlock(), _createBlock(_component_v_tab, {
                                          key: 2,
                                          value: "MATERIAL"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("素材 (" + _toDisplayString(_unref(courseMaterials).length + _unref(lessonMaterials).length) + ") ", 1 /* TEXT */)
                                          ]),
                                          _: 1 /* STABLE */
                                        }))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue"]),
                                (_unref(schoolSetting) && _unref(schoolSetting).useAiChatLesson)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      class: "lesson-new-thread-btn",
                                      variant: "tonal",
                                      color: "primary",
                                      size: "small",
                                      onClick: _cache[15] || (_cache[15] = ($event: any) => (emitCreateThread(1)))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { start: "" }, {
                                          default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                            _createTextVNode("mdi-comment-plus", -1 /* CACHED */)
                                          ]))]),
                                          _: 1 /* STABLE */
                                        }),
                                        _cache[51] || (_cache[51] = _createTextVNode("新規スレッド ", -1 /* CACHED */))
                                      ]),
                                      _: 1 /* STABLE */
                                    }))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _createVNode(_component_v_window, {
                                modelValue: _unref(tab),
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_isRef(tab) ? (tab).value = $event : null)),
                                class: "h-full"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_window_item, {
                                    value: 'LIVECHAT',
                                    class: "h-full"
                                  }, {
                                    default: _withCtx(() => [
                                      (_unref(currentLesson).lesson.lessonType == 'live')
                                        ? (_openBlock(), _createBlock(LiveChat, {
                                            ref_key: "liveChatContainer",
                                            ref: liveChatContainer,
                                            key: "liveChat",
                                            targetableId: String(_unref(currentLessonId) || _unref(currentLesson).lesson.id),
                                            targetableType: 'Lesson',
                                            class: "h-full"
                                          }, null, 8 /* PROPS */, ["targetableId"]))
                                        : _createCommentVNode("v-if", true)
                                    ]),
                                    _: 1 /* STABLE */
                                  }),
                                  (_unref(currentLessonId) && _unref(schoolSetting) && _unref(schoolSetting).useAiChatLesson)
                                    ? (_openBlock(), _createBlock(_component_v_window_item, {
                                        key: 0,
                                        value: 'CHAT',
                                        class: "h-full"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(), _createBlock(MesageContainer, {
                                            "practice-enabled": true,
                                            "course-id": Number(courseIdStr.value),
                                            "practice-discussion": _unref(practiceDiscussion),
                                            "active-view": _unref(activeView),
                                            onPracticeCreated: _unref(openPractice),
                                            onPracticeGenerating: _unref(onPracticeGenerating),
                                            onPracticeProgress: _unref(onPracticeProgress),
                                            ref_key: "mesageContainer",
                                            ref: mesageContainer,
                                            key: _unref(currentLessonId),
                                            targetableId: _unref(currentLessonId),
                                            targetableType: 'Lesson',
                                            toggleCreateThreadBtn: toggleCreateThreadBtn,
                                            "using-deepseek": _unref(schoolSetting) && _unref(schoolSetting).usingDeepSeek,
                                            class: "h-full"
                                          }, null, 8 /* PROPS */, ["course-id", "practice-discussion", "active-view", "onPracticeCreated", "onPracticeGenerating", "onPracticeProgress", "targetableId", "using-deepseek"]))
                                        ]),
                                        _: 1 /* STABLE */
                                      }))
                                    : _createCommentVNode("v-if", true),
                                  (_unref(currentLessonId) && _unref(schoolSetting) && _unref(schoolSetting).useAiChatLesson)
                                    ? (_openBlock(), _createBlock(_component_v_window_item, {
                                        key: 1,
                                        value: 'THREAD',
                                        class: "h-full"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(), _createBlock(ThreadContainer, {
                                            key: _unref(currentLessonId),
                                            targetableId: _unref(currentLessonId),
                                            targetableType: 'Lesson',
                                            parentTab: 1,
                                            onUpdateParentTab: updateParentTab
                                          }, null, 8 /* PROPS */, ["targetableId"]))
                                        ]),
                                        _: 1 /* STABLE */
                                      }))
                                    : _createCommentVNode("v-if", true),
                                  _createVNode(_component_v_window_item, {
                                    value: 'QA',
                                    class: "h-full"
                                  }, {
                                    default: _withCtx(() => [
                                      (questionMode.value == 'list')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                            _createElementVNode("div", _hoisted_62, [
                                              _createElementVNode("div", _hoisted_63, [
                                                _cache[52] || (_cache[52] = _createElementVNode("h2", { class: "mt-1" }, null, -1 /* CACHED */)),
                                                _createVNode(UserQuestionDialog, {
                                                  courseId: courseIdStr.value,
                                                  lessonId: _unref(currentLesson).lesson.id.toString()
                                                }, null, 8 /* PROPS */, ["courseId", "lessonId"])
                                              ]),
                                              _createVNode(_component_v_divider, { class: "mt-2" })
                                            ]),
                                            _createVNode(UserQuestionList, {
                                              "relativeable-type": "Lesson",
                                              "relativeable-id": _unref(currentLesson).lesson.id,
                                              onClickQuestion: onClickQuestion
                                            }, null, 8 /* PROPS */, ["relativeable-id"])
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                      _createElementVNode("div", _hoisted_64, [
                                        (questionMode.value == 'show')
                                          ? (_openBlock(), _createBlock(UserQuestionDetailModal, {
                                              key: 0,
                                              question: currentQuestion.value,
                                              onBack: onBackQuestionList,
                                              showCloseButton: false
                                            }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                                              (newQuestionCreatedFlag.value)
                                                ? {
                                                    name: "notice",
                                                    fn: _withCtx(() => [
                                                      _createElementVNode("div", {
                                                        class: "d-flex bg-success text-white p-1 justify-content-between align-items-center",
                                                        onClick: _cache[16] || (_cache[16] = ($event: any) => (newQuestionCreatedFlag.value = false))
                                                      }, [...(_cache[53] || (_cache[53] = [
                                                        _createElementVNode("div", null, "無事に投稿されました", -1 /* CACHED */),
                                                        _createElementVNode("div", null, [
                                                          _createElementVNode("i", { class: "bi bi-x-lg" })
                                                        ], -1 /* CACHED */)
                                                      ]))])
                                                    ]),
                                                    key: "0"
                                                  }
                                                : undefined
                                            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["question"]))
                                          : _createCommentVNode("v-if", true)
                                      ])
                                    ]),
                                    _: 1 /* STABLE */
                                  }),
                                  _createVNode(_component_v_window_item, { value: 'MATERIAL' }, {
                                    default: _withCtx(() => [
                                      (_unref(courseMaterials).length > 0 || _unref(lessonMaterials).length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                            (_unref(courseMaterials).length > 0)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _cache[55] || (_cache[55] = _createElementVNode("h5", { class: "border-bottom mt-2" }, "コースの素材一覧", -1 /* CACHED */)),
                                                  _createVNode(_component_v_list, {
                                                    density: "compact",
                                                    class: "mb-5"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(courseMaterials), (item, index) => {
                                                        return (_openBlock(), _createBlock(_component_v_list_item, {
                                                          key: index,
                                                          onClick: _withModifiers(($event: any) => (_unref(downloadFile)(item.link)), ["prevent"])
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_66, [
                                                              _createVNode(_component_v_list_item_title)
                                                            ]),
                                                            _createElementVNode("span", null, [
                                                              _createVNode(_component_v_list_item_title, null, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(item.fileName), 1 /* TEXT */)
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                              }, 1024 /* DYNAMIC_SLOTS */)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_67, [
                                                              _createVNode(_component_v_icon, null, {
                                                                default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                                                                  _createTextVNode("mdi-download", -1 /* CACHED */)
                                                                ]))]),
                                                                _: 1 /* STABLE */
                                                              })
                                                            ])
                                                          ]),
                                                          _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                                                      }), 128 /* KEYED_FRAGMENT */))
                                                    ]),
                                                    _: 1 /* STABLE */
                                                  })
                                                ], 64 /* STABLE_FRAGMENT */))
                                              : _createCommentVNode("v-if", true),
                                            (_unref(lessonMaterials).length > 0)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                  _cache[57] || (_cache[57] = _createElementVNode("h5", { class: "border-bottom" }, "レッスンの素材一覧", -1 /* CACHED */)),
                                                  _createVNode(_component_v_list, { density: "compact" }, {
                                                    default: _withCtx(() => [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lessonMaterials), (item, index) => {
                                                        return (_openBlock(), _createBlock(_component_v_list_item, {
                                                          key: index,
                                                          onClick: _withModifiers(($event: any) => (_unref(downloadFile)(item.link)), ["prevent"])
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_68, [
                                                              _createVNode(_component_v_list_item_title)
                                                            ]),
                                                            _createElementVNode("span", null, [
                                                              _createVNode(_component_v_list_item_title, null, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(item.fileName), 1 /* TEXT */)
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                              }, 1024 /* DYNAMIC_SLOTS */)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_69, [
                                                              _createVNode(_component_v_icon, null, {
                                                                default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                                                                  _createTextVNode("mdi-download", -1 /* CACHED */)
                                                                ]))]),
                                                                _: 1 /* STABLE */
                                                              })
                                                            ])
                                                          ]),
                                                          _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                                                      }), 128 /* KEYED_FRAGMENT */))
                                                    ]),
                                                    _: 1 /* STABLE */
                                                  })
                                                ], 64 /* STABLE_FRAGMENT */))
                                              : _createCommentVNode("v-if", true)
                                          ]))
                                        : _createCommentVNode("v-if", true)
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["modelValue"])
                            ], 512 /* NEED_PATCH */), [
                              [_vShow, !_unref(practiceTaking)]
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["size", "min-size"]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["class"])
              ])
            ])
          ])
        ]),
        _createVNode(_component_v_dialog, {
          modelValue: _unref(codeDialog),
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_isRef(codeDialog) ? (codeDialog).value = $event : null)),
          "max-width": "800"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, {
                  innerHTML: _unref(dialogHTML),
                  class: "d-flex pt-6"
                }, null, 8 /* PROPS */, ["innerHTML"]),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (codeDialog.value = false))
                    }, {
                      default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                        _createTextVNode("近い", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_70, [
        _createVNode(_component_v_progress_circular, {
          indeterminate: "",
          color: "primary",
          size: "48"
        })
      ]))
}
}

})